module.exports = __webpack_public_path__ + "static/media/professionals_charts.bd2252f8.png";